<template>
  <div>
    <div class="row">
        <div class="col-md-10">
          <h1>Calculator</h1>
        </div>
    </div>
    <div class="row">
              <!-- YEAR PICKLIST -->
      <div class="col-md-4">
        <label for="year">Year</label>
        <select class="form-control" name="year" id="year" v-model="selected_year" @change="regenerateChart()">
          <option v-for="year in years" :key="year.year">{{year.year}}</option>
        </select>
      </div>
      <!-- INPUT -->
      <div class="col-md-4" v-for="(field, key, index) in fields" :key="field.name">
        <label :for="field.name" v-html='field.label'/>
        <input :type="field.type" :name="field.name" v-model.number="field.value" :placeholder="field.placeholder" @change="regenerateChart()"/>
        <div v-if="(key%3)==1" class="w-100"/>
      </div>
      <br/>
      <div class="w-100 mb-5"><hr/></div>
      <div class="col-md-12">
        <!-- LEGEND -->
        <div class="row mb-12 border legend sticky">
          <h2 class="col-md-12 p-3">Legend</h2>
          <div class="col-sm-3 mb-3" v-for="(output, key, index) in outputs" :key="output.name">
              <label :for="output.name" v-html="output.name"/>:
              <span :name="output.name" v-html="output.label"/>
          </div>
        </div>
        <div class="row mb-12 border">
          <!-- RAW VALUES -->
          <h2 class="col-md-12 p-3">Raw Values</h2>
          <div class="col-sm-3 mb-3" v-for="(output, key, index) in outputs" :key="output.name">
              <label :for="output.name" v-html="output.name" class="mr-1"/>
              <div :name="output.name" v-html="calculate(false)[output.key]"/>
              <!-- <div v-if="(key%4)==1" class="w-100 mb-4"/> -->
          </div>
        </div>
        <div class="row mb-12 border">
          <!-- NORMALIZED VALUES -->
          <h2 class="col-md-12 p-3">Normalized Values</h2>
          <div class="col-sm-3 mb-3" v-for="(output, key, index) in outputs" :key="output.name">
              <label :for="output.name" v-html="output.name"/>
              <label class="mr-1">'</label>
              <div :name="output.name" v-html="calculate(true)[output.key]"/>
              <!-- <div v-if="(key%4)==1" class="w-100 mb-4"/> -->
          </div>
          <div class="col-sm-12 text-center border-top">If out of range please contact <a href="./team">our team</a>.</div>
        </div>
        <div class="row mb-12 border">
          <h2 class="col-md-12 p-3">Chart - Comparison with {{ selected_company }} in the year {{ selected_year }}</h2>
          <div class="col-sm-12 mb-3">
            <div><label for="company">Company</label></div>
            <select name="company" id="company" v-model="selected_company" @change="regenerateChart()">
              <option>All</option>
              <option v-for="company in company_names" :key="company.name" >{{ company.name }}</option>
            </select>
          </div>
          <!-- <div class="col-sm-12 mb-3">
            <label :for="year2">Year</label>
            <select class="form-control" name="year2" id="year2" v-model="selected_year" @change="regenerateChart()">
              <option v-for="year in years" :key="year.year">{{year.year}}</option>
            </select>
          </div> -->
          <div class="col-sm-12 mb-3" style="overflow: none; max-width: 100%">
              <div id="canvas-wrapper" class="chart-container" style="position: relative; height:90vh">

                <canvas id="chart"></canvas>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
  export default {
    name: 'calculator',
    data() {
      return {
        company_names: [],
        outputs: [
          {
            "key": "V1",
            "name": "V<sub>1</sub>",
            "label": "Market Share (%)"
          },
          {
            "key": "V2",
            "name": "V<sub>2</sub>",
            "label": "Cash Flow Margin (%)"
          },
          {
            "key": "V3",
            "name": "V<sub>3</sub>",
            "label": "Continuity ($)"
          },
          {
            "key": "V4",
            "name": "V<sub>4</sub>",
            "label": "Conception ($)"
          },
          {
            "key": "V5",
            "name": "V<sub>5</sub>",
            "label": "Inventory Turnover"
          },
          {
            "key": "V6",
            "name": "V<sub>6</sub>",
            "label": "Water Consumption per vehicle produced (m<sup>3</sup>/#)"
          },
          {
            "key": "V7",
            "name": "V<sub>7</sub>",
            "label": "Energy Consumption per vehicle produced (MWh/#)"
          },
          {
            "key": "V8",
            "name": "V<sub>8</sub>",
            "label": "CO<sub>2</sub> Emission per vehicle produced (t/#)"
          }
        ],
        fields: [
          {
              "name": "prod_vol",
              "label": "Production Volume (#)",
              "placeholder" : "Production Volume",
              "class": "",
              "type": "number",
              "value": null
          },
          {
              "name": "cashflow",
              "label": "Cash Flows from operation activities ($)",
              "placeholder" : "Cash Flow",
              "class": "currency",
              "type": "number",
              "value": null
          },
          {
              "name": "net_sales",
              "label": "Net Sales ($)",
              "placeholder" : "Net Sales",
              "class": "currency",
              "type": "number",
              "value": null
          },
          {
              "name": "profit",
              "label": "Profit ($)",
              "placeholder" : "Profit",
              "class": "currency",
              "type": "number",
              "value": null
          },
          {
              "name": "rd_expenses",
              "label": "R&D Expenses ($)",
              "placeholder" : "R&D Expenses",
              "class": "currency",
              "type": "number",
              "value": null
          },
          {
              "name": "cost_goods_sold",
              "label": "Cost of Goods Sold ($)",
              "placeholder" : "Cost of Goods Sold",
              "class": "currency",
              "type": "number",
              "value": null
          },
          {
              "name": "inventory",
              "label": "Inventory Size ($)",
              "placeholder" : "Inventory Size",
              "class": "currency",
              "type": "number",
              "value": null
          },
          {
              "name": "water_consumption",
              "label": "Water Consumption (m<sup>3</sup>)",
              "placeholder" : "Water Consumption",
              "class": "",
              "type": "number",
              "value": null
          },
          {
              "name": "energy_consumption",
              "label": "Energy Consumption (MWh)",
              "placeholder" : "Energy Consumption",
              "class": "",
              "type": "number",
              "value": null
          },
          {
              "name": "co2_emission",
              "label": "CO<sub>2</sub> Emission (t)",
              "placeholder" : "CO2 Emission",
              "class": "",
              "type": "number",
              "value": null
          },
          {
              "name": "nb_employee",
              "label": "Number of Employees (#)",
              "placeholder" : "No. Employees",
              "class": "",
              "type": "number",
              "value": null
          }
        ],
        years: [],
        selected_year: "2017",
        selected_company: "All",
        curency_symbol: '\u0024 '
    	}
    },
    methods: {
      currencyFormat: function (num) {
          return isNaN(num) ? 0 : this.curency_symbol + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      },
      getAllCompanyNames: function(){
        let self = this;
				this.axios.get("php/api.php?action=names").then(
          response => {
            self.company_names = response.data;
          },
          error => {
            self.company_names = [{"name":"Audi AG"},{"name":"BMW"},{"name":"Daimler Group"},{"name":"FCA"},{"name":"Ford"},{"name":"GM"},{"name":"Honda "},{"name":"Hyundai"},{"name":"Nissan"},{"name":"PSA"},{"name":"Renault"},{"name":"Toyota"}];
          }
				);
			},
      getAllYears: function () {
        let self = this;
        this.axios.get("php/api.php?action=years").then(
          response => {
            self.years = response.data;
          },
          error => {
            self.years=[{"year":2017},{"year":2016},{"year":2015},{"year":2014},{"year":2013},{"year":2012},{"year":2011},{"year":2010},{"year":2009},{"year":2008}];
          }
        );
      },
      regenerateChart: function () {
				this.generateAreaChart();
			},
      generateAreaChart: function() {
        let self = this;
        let chart = document.getElementById('chart').getContext('2d');

    		function generateData() {
          let arr = [];
          for(var i=0;i<8;i++) {
            //let val = 2 - Math.random();
            arr.push(self.calculate(true)["V" + (i+1)]);
          }

    			return arr;
    		}

        let labels = ['V1\' (%)', 'V2\' (%)', 'V3\' (US$)', 'V4\' (US$)', 'V5\'', 'V6\' (m3)', 'V7\' (MWh)', 'V8\' (t)'];
        let bgColorSet = ["#7394c9", "#e0974f", "#85ba5d", "#d15e60", "#7f8585", "#ffee66", "#ab6857", "#ccc274", "#138D75", "#333333", "#444e86", "#955196", "#ee80A0", "#ff2222", "#ffa600"];
        //let borderColorSet = ["#466999", "#b06523", "#588a2f", "#a13032", "#515757", "#603b78", "#7d3b2a", "#9e9447", "#0E6655", "#003f5c", "#444e86", "#955196", "#dd5182", "#ff2200", "#ffa600"];
        let datasets = [];

        datasets.push({
            backgroundColor: bgColorSet[0],
            borderColor: bgColorSet[0],
            data: generateData(),
            label: 'My Data',
            fill: false
        });

        // let data = [
        //    {"Name":"BMW","V1":1.974,"V2":1.77,"V3":1.982,"V4":1.204,"V5":1.272,"V6":0.524,"V7":0.038,"V8":0.12},
        //    {"Name":"Audi AG","V1":1.974,"V2":1.90,"V3":1.982,"V4":1.704,"V5":1.972,"V6":0.824,"V7":0.045,"V8":0.14}
        //  ];

        $.ajax({
            url: "php/graph.php?year=" + self.selected_year + "&company=" + self.selected_company,
            method: "GET",
            success: function(data) {
              let count = 1;

              for(var i in data) {
                datasets.push({
                    backgroundColor: bgColorSet[count],
                    borderColor: bgColorSet[count],
                    data: [
                      data[i].V1,
                      data[i].V2,
                      data[i].V3,
                      data[i].V4,
                      data[i].V5,
                      data[i].V6,
                      data[i].V7,
                      data[i].V8
                    ],
                    label: data[i].Name,
                    fill: false
                });

                count++;
              }

              console.log(datasets);
              $("#canvas-wrapper").html("").html('<canvas id="chart"></canvas>');

              var ctx = $("#chart");

              var spiderGraph = new Chart('chart', {
                type: 'radar',
                data: {
                  labels: labels,
                  datasets: datasets
                },
                options: {
                  maintainAspectRatio: true,
                  spanGaps: false,
                  elements: {
                    line: {
                      tension: 0.000001
                    }
                  },
                  plugins: {
                    filler: {
                      propagate: false
                    },
                    'samples-filler-analyser': {
                      target: 'chart-analyser'
                    }
                  }
                }
              });
            }
        });
      }
    },
    mounted: function(){
      this.getAllCompanyNames();
      this.getAllYears();

			let year = 2017;
			let company = 'All';

			this.generateAreaChart(year, company);
    },
  	computed: {
      calculate : function () {
        let self = this;
        let year = this.selected_year;

        let v1 = getFieldValue("prod_vol") / getFixedSumProdVol();
        let v2 = getFieldValue("cashflow") / getFieldValue("net_sales");
        let v3 = getFieldValue("profit") / getFieldValue("nb_employee");
        let v4 = getFieldValue("rd_expenses") / getFieldValue("nb_employee");
        let v5 = getFieldValue("cost_goods_sold") / getFieldValue("inventory");
        let v6 = getFieldValue("water_consumption") / getFieldValue("prod_vol");
        let v7 = getFieldValue("energy_consumption") / getFieldValue("prod_vol");
        let v8 = getFieldValue("co2_emission") / getFieldValue("prod_vol");

        function getFieldValue(field_name) {
          let index = self.fields.findIndex(x => x.name === field_name);
          return self.fields[index].value;
        }

        function prettyResult(result) {
          return isNaN(result) || result == 0 ? '' : parseFloat(result.toFixed(4));
        }

        function checkRange(value, norm_val, min, max) {
          //console.log(value + ', ' + norm_val + ', ' + min + ', ' + max);
          let isOutOfRange = false;

          if(value > max || value < min){
            isOutOfRange = true;
          }

          if(isOutOfRange) return '<span style="color:red">Out of range</span> <span style="font-size:8pt">[' + min.toFixed(4) + ',' + max.toFixed(4) + '] (' + prettyResult(value) + ')</span>';
          else return norm_val;
        }

        function getFixedSumProdVol() {
          let value = 0;

          switch (year) {
            case "2008" : value = 70729696; break;
            case "2009" : value = 61762324; break;
            case "2010" : value = 77583519; break;
            case "2011" : value = 79880920; break;
            case "2012" : value = 84236171; break;
            case "2013" : value = 87595998; break;
            case "2014" : value = 89776465; break;
            case "2015" : value = 90780583; break;
            case "2016" : value = 94976569; break;
            case "2017" : value = 97302534; break;
          }

          return value;
        }

        return normalized => {
          if(!normalized) {
            return {
              V1 : prettyResult(v1),
              V2 : prettyResult(v2),
              V3 : prettyResult(v3),
              V4 : prettyResult(v4),
              V5 : prettyResult(v5),
              V6 : prettyResult(v6),
              V7 : prettyResult(v7),
              V8 : prettyResult(v8)
            }
          } else {
            switch (year) {
              case "2008" :
              // OK
                var v1_norm = (v1) ? checkRange(v1, prettyResult(1+(v1-0.019)/(13.0606810468972-0.019)),0.019, 13.0606810468972) : null;
                var v2_norm = (v2) ? checkRange(v2, prettyResult(1+(v2+8.618)/(20.4372427016561+8.618)),-8.618, 20.4372427016561) : null;
                var v3_norm = (v3) ? checkRange(v3, prettyResult(1+(v3+121279.835)/(122742.705798611+121279.835)),-121279.835,122742.705798611) : null;
                var v4_norm = (v4) ? checkRange(v4, prettyResult(1+(v4-13936.684009922)/(160840.420117698-13936.684009922)),13936.684009922,160840.420117698) : null;
                var v5_norm = (v5) ? checkRange(v5, prettyResult(1+(v5-1.305)/(14.7485495474588-1.305)),1.305,14.7485495474588) : null;
                var v6_norm = (v6) ? checkRange(v6, prettyResult(1+(13.36-v6)/(13.36-0.025)),0.025,13.36) : null;
                var v7_norm = (v7) ? checkRange(v7, prettyResult(1+(5.5-v7)/(5.5-0.711)),0.711,5.5) : null;
                var v8_norm = (v8) ? checkRange(v8, prettyResult(1+(1.16962536365256-v8)/(1.16962536365256-0.356954948386481)),0.052,1.73803142989994) : null;

                break;
              case "2009" :
              // OK
                var v1_norm = (v1) ? checkRange(v1, prettyResult(1+(v1-0.013)/(11.7133529496073-0.013)),0.013,11.7133529496073) : null;
                var v2_norm = (v2) ? checkRange(v2, prettyResult(1+(v2-0.168)/(24.3116090303174-0.168)),0.168, 24.3116090303174) : null;
                var v3_norm = (v3) ? checkRange(v3, prettyResult(1+(v3+25277.51196)/(304332.746666667+25277.51196)),-25277.51196,304332.746666667) : null;
                var v4_norm = (v4) ? checkRange(v4, prettyResult(1+(v4-12765.3435007105)/(125944.328888889-12765.3435007105)),12765.3435007105,125944.328888889) : null;
                var v5_norm = (v5) ? checkRange(v5, prettyResult(1+(v5-1.341)/(14.0554449815183-1.341)),1.341,14.0554449815183) : null;
                var v6_norm = (v6) ? checkRange(v6, prettyResult(1+(15.0946654207126-v6)/(15.0946654207126-0.054)),0.054,15.0946654207126) : null;
                var v7_norm = (v7) ? checkRange(v7, prettyResult(1+(11.8784292858362-v7)/(11.8784292858362-0.795)),0.795,11.8784292858362) : null;
                var v8_norm = (v8) ? checkRange(v8, prettyResult(1+(1.74976042509125-v8)/(1.74976042509125-0.067)),0.067,1.74976042509125) : null;

                break;
              case "2010" :
              // OK
                var v1_norm = (v1) ? checkRange(v1, prettyResult(1+(v1-0.015)/(11.0298567405791-0.015)),0.015, 11.0298567405791) : null;
                var v2_norm = (v2) ? checkRange(v2, prettyResult(1+(v2-0.064)/(21.5592996543461-0.064)),0.064, 21.5592996543461) : null;
                var v3_norm = (v3) ? checkRange(v3, prettyResult(1+(v3-7551.138)/(210103.37604923-7551.138)),7551.138,210103.37604923) : null;
                var v4_norm = (v4) ? checkRange(v4, prettyResult(1+(v4-6591.12023593102)/(55600.129-6591.12023593102)),6591.12023593102,55600.129) : null;
                var v5_norm = (v5) ? checkRange(v5, prettyResult(1+(v5-1.778)/(21.6828660808943-1.778)),1.778,21.6828660808943) : null;
                var v6_norm = (v6) ? checkRange(v6, prettyResult(1+(11.6776542209034-v6)/(11.6776542209034-0.041)),0.041,11.6776542209034) : null;
                var v7_norm = (v7) ? checkRange(v7, prettyResult(1+(7.62442916833776-v7)/(7.62442916833776-1.934)),1.934,7.62442916833776) : null;
                var v8_norm = (v8) ? checkRange(v8, prettyResult(1+(1.79441525613706-v8)/(1.79441525613706-0.179)),0.179,1.79441525613706) : null;

                break;
              case "2011" :
              // OK
                var v1_norm = (v1) ? checkRange(v1, prettyResult(1+(v1-1.427)/(11.3064171018561-1.427)),1.427, 11.3064171018561) : null;
                var v2_norm = (v2) ? checkRange(v2, prettyResult(1+(v2+0.653)/(15.241862263754+0.653)),-0.653, 15.241862263754) : null;
                var v3_norm = (v3) ? checkRange(v3, prettyResult(1+(v3+12420.28094)/(178282.605218145+12420.28094)),-12420.28094,178282.605218145) : null;
                var v4_norm = (v4) ? checkRange(v4, prettyResult(1+(v4-5951.65078610666)/(54492.7538770181-5951.65078610666)),5951.65078610666,54492.7538770181) : null;
                var v5_norm = (v5) ? checkRange(v5, prettyResult(1+(v5-1.45)/(23.9142960969996-1.45)),1.45,23.9142960969996) : null;
                var v6_norm = (v6) ? checkRange(v6, prettyResult(1+(10.8717380281763-v6)/(10.8717380281763-2.25)),2.25,10.8717380281763) : null;
                var v7_norm = (v7) ? checkRange(v7, prettyResult(1+(6.86-v7)/(6.86-1.719)),1.719,6.86) : null;
                var v8_norm = (v8) ? checkRange(v8, prettyResult(1+(1.60781107939059-v8)/(1.60781107939059-0.149)),0.149,1.60781107939059) : null;

                break;
              case "2012" :
              // OK
                var v1_norm = (v1) ? checkRange(v1, prettyResult(1+(v1-1.317)/(11.9953505484004-1.317)),1.317, 11.9953505484004) : null;
                var v2_norm = (v2) ? checkRange(v2, prettyResult(1+(v2+0.962)/(12.5976502429723+0.962)),-0.962, 12.5976502429723) : null;
                var v3_norm = (v3) ? checkRange(v3, prettyResult(1+(v3+3717.492)/(120015.8140444+3717.492)),-3717.492,120015.8140444) : null;
                var v4_norm = (v4) ? checkRange(v4, prettyResult(1+(v4-5499.712)/(57695.433955107-5499.712)),5499.712,57695.433955107) : null;
                var v5_norm = (v5) ? checkRange(v5, prettyResult(1+(v5-1.221)/(17.0386790318932-1.221)),1.221,17.0386790318932) : null;
                var v6_norm = (v6) ? checkRange(v6, prettyResult(1+(12.48-v6)/(12.48-1.72)),1.72,12.48) : null;
                var v7_norm = (v7) ? checkRange(v7, prettyResult(1+(6.2-v7)/(6.2-1.77442902794368)),1.77442902794368,5.2) : null;
                var v8_norm = (v8) ? checkRange(v8, prettyResult(1+(1.51971253015736-v8)/(1.51971253015736-0.133)),0.133,1.51971253015736) : null;

                break;
              case "2013" :
              // OK
                var v1_norm = (v1) ? checkRange(v1, prettyResult(1+(v1-1.213)/(11.7870624637441-1.213)),1.213, 11.7870624637441) : null;
                var v2_norm = (v2) ? checkRange(v2, prettyResult(1+(v2-1.384)/(50.6536967292878-1.384)),1.384, 50.6536967292878) : null;
                var v3_norm = (v3) ? checkRange(v3, prettyResult(1+(v3+2837.620247)/(170518.371238138+2837.620247)),-2837.620247,170518.371238138) : null;
                var v4_norm = (v4) ? checkRange(v4, prettyResult(1+(v4-5930.84208466355)/(63083.7908720486-5930.84208466355)),5930.84208466355,63083.7908720486) : null;
                var v5_norm = (v5) ? checkRange(v5, prettyResult(1+(v5-0.674)/(16.6203052422031-0.674)),0.674,16.6203052422031) : null;
                var v6_norm = (v6) ? checkRange(v6, prettyResult(1+(12.67-v6)/(12.67-1.47)),1.47,12.67) : null;
                var v7_norm = (v7) ? checkRange(v7, prettyResult(1+(6.3-v7)/(6.3-1.1)),1.1,6.3) : null;
                var v8_norm = (v8) ? checkRange(v8, prettyResult(1+(1.88379837968641-v8)/(1.88379837968641-0.313)),0.131,1.88379837968641) : null;

                break;
              case "2014" :
              // OK
                var v1_norm = (v1) ? checkRange(v1, prettyResult(1+(v1-1.053)/(11.6682451241536-1.053)),1.053, 11.6682451241536) : null;
                var v2_norm = (v2) ? checkRange(v2, prettyResult(1+(v2+0.981)/(13.7970141484002+0.981)),-0.981, 13.7970141484002) : null;
                var v3_norm = (v3) ? checkRange(v3, prettyResult(1+(v3+9005.90213169817)/(157083.421432959+9005.90213169817)),-9005.90213169817,157083.421432959) : null;
                var v4_norm = (v4) ? checkRange(v4, prettyResult(1+(v4-4993.81297255222)/(57770.7975102658-4993.81297255222)),4993.81297255222,57770.7975102658) : null;
                var v5_norm = (v5) ? checkRange(v5, prettyResult(1+(v5-1.219)/(16.0556054963401-1.219)),1.219,16.0556054963401) : null;
                var v6_norm = (v6) ? checkRange(v6, prettyResult(1+(10.8323685323834-v6)/(10.8323685323834-1.62)),1.62,10.8323685323834) : null;
                var v7_norm = (v7) ? checkRange(v7, prettyResult(1+(6.01-v7)/(6.01-1.09)),1.09,6.01) : null;
                var v8_norm = (v8) ? checkRange(v8, prettyResult(1+(1.65765455310221-v8)/(1.65765455310221-0.111)),0.111,1.65765455310221) : null;

                break;
              case "2015" :
              // OK
                var v1_norm = (v1) ? checkRange(v1, prettyResult(1+(v1-1.113)/(11.1079161058043-1.113)),1.113, 11.1079161058043) : null;
                var v2_norm = (v2) ? checkRange(v2, prettyResult(1+(v2-1.041)/(15.7055186687602-1.041)),1.041, 15.7055186687602) : null;
                var v3_norm = (v3) ? checkRange(v3, prettyResult(1+(v3-314.967589744902)/(81994.0673551716-314.967589744902)),314.967589744902,81994.0673551716) : null;
                var v4_norm = (v4) ? checkRange(v4, prettyResult(1+(v4-4643.37916682838)/(48771.9891745841-4643.37916682838)),4643.37916682838,48771.9891745841) : null;
                var v5_norm = (v5) ? checkRange(v5, prettyResult(1+(v5-1.595)/(15.3278962001854-1.595)),1.595,15.3278962001854) : null;
                var v6_norm = (v6) ? checkRange(v6, prettyResult(1+(11.31-v6)/(11.31-1.52)),1.52,11.31) : null;
                var v7_norm = (v7) ? checkRange(v7, prettyResult(1+(5.12450547983388-v7)/(5.12450547983388-1.07)),1.07,5.12450547983388) : null;
                var v8_norm = (v8) ? checkRange(v8, prettyResult(1+(1.51360062211749-v8)/(1.51360062211749-0.121)),0.121,1.51360062211749) : null;

                break;
              case "2016" :
              // OK
                var v1_norm = (v1) ? checkRange(v1, prettyResult(1+(v1-1.14204799291076)/(10.753690207529-1.14204799291076)),1.14204799291076, 10.753690207529) : null;
                var v2_norm = (v2) ? checkRange(v2, prettyResult(1+(v2-1.06457489615695)/(12.6725896454642-1.06457489615695)),1.06457489615695, 12.6725896454642) : null;
                var v3_norm = (v3) ? checkRange(v3, prettyResult(1+(v3-14147.3384238283)/(182315.122358443-14147.3384238283)),14147.3384238283,182315.122358443) : null;
                var v4_norm = (v4) ? checkRange(v4, prettyResult(1+(v4-3989.11910804067)/(43968.7773892919-3989.11910804067)),3989.11910804067,43968.7773892919) : null;
                var v5_norm = (v5) ? checkRange(v5, prettyResult(1+(v5-1.62102552643056)/(29.6303734849735-1.62102552643056)),1.62102552643056,29.6303734849735) : null;
                var v6_norm = (v6) ? checkRange(v6, prettyResult(1+(9.5-v6)/(9.5-1.52)),1.52,9.5) : null;
                var v7_norm = (v7) ? checkRange(v7, prettyResult(1+(5.95-v7)/(5.95-1.08)),1.05,5.95) : null;
                var v8_norm = (v8) ? checkRange(v8, prettyResult(1+(1.16289655445388-v8)/(0.125-0.356954948386481)),0.125,1.16289655445388) : null;

                break;
              case "2017" :
              // OK
                var v1_norm = (v1) ? checkRange(v1, prettyResult(1+(v1-1.25497656618069)/(10.7069606224232-1.25497656618069)),1.25497656618069, 10.7069606224232) :  null;
                var v2_norm = (v2) ? checkRange(v2, prettyResult(1+(v2-4.06991137292481)/(14.3297454586547-4.06991137292481)),4.06991137292481, 14.3297454586547) : null;
                var v3_norm = (v3) ? checkRange(v3, prettyResult(1+(v3-21119.1911458303)/(250663.628328996-21119.1911458303)),21119.1911458303,250663.628328996) : null;
                var v4_norm = (v4) ? checkRange(v4, prettyResult(1+(v4-4540.01079047073)/(47648.3124780421-4540.01079047073)),4540.01079047073,47648.3124780421) : null;
                var v5_norm = (v5) ? checkRange(v5, prettyResult(1+(v5-0.783861181180582)/(30.8895263925563-0.783861181180582)),0.783861181180582,30.8895263925563) : null;
                var v6_norm = (v6) ? checkRange(v6, prettyResult(1+(9.51-v6)/(9.51-1.87)),1.87,9.51) : null;
                var v7_norm = (v7) ? checkRange(v7, prettyResult(1+(5.6-v7)/(5.6-0.203)),0.203,5.6) : null;
                var v8_norm = (v8) ? checkRange(v8, prettyResult(1+(1.16962536365256-v8)/(1.16962536365256-0.356954948386481)),0.356954948386481,1.16962536365256) : null;

                break;
            }

            return {
              V1 : v1_norm,
              V2 : v2_norm,
              V3 : v3_norm,
              V4 : v4_norm,
              V5 : v5_norm,
              V6 : v6_norm,
              V7 : v7_norm,
              V8 : v8_norm
            }
          }
        }
      }
    }
  }
</script>
